<script setup>
const messages = [
  'Carregando…',
  'Aguarde um instante…',
  'Obrigado por aguardar…',
];
</script>

<template>
  <span class="talkvia-loading-messages" aria-hidden="true">
    <span v-for="message in messages" :key="message">{{ message }}</span>
  </span>
</template>

<style scoped>
.talkvia-loading-messages {
  display: inline-grid;
  max-width: 100%;
  font-size: 11px;
  line-height: 1.5;
  font-weight: 400;
  text-align: center;
}
.talkvia-loading-messages > span {
  grid-area: 1 / 1;
  opacity: 0;
  animation: loading-message 9s ease-in-out infinite;
}
.talkvia-loading-messages > span:nth-child(2) {
  animation-delay: 3s;
}
.talkvia-loading-messages > span:nth-child(3) {
  animation-delay: 6s;
}
@keyframes loading-message {
  0%,
  28% {
    opacity: 1;
  }
  33%,
  100% {
    opacity: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .talkvia-loading-messages > span {
    animation: none;
  }
  .talkvia-loading-messages > span:first-child {
    opacity: 1;
  }
}
</style>
